import { MenuGroup } from '@rehau/shared/models';

import { SortGroups } from './mobileMenuItem.types';

export const sortGroups: SortGroups = (group1: MenuGroup, group2: MenuGroup): number => group1.order - group2.order;
